export const isValidPassword = (password: string) => {
  // strong regex: 1 uppercase, 1 lowercase, 1 number, 1 special, min length 8
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?/=:;£"_\-'])(?=.{8,})/
  return regex.test(password)
}